import { render, staticRenderFns } from "./analiseOrdem.vue?vue&type=template&id=ec1923d2"
import script from "./analiseOrdem.vue?vue&type=script&lang=js"
export * from "./analiseOrdem.vue?vue&type=script&lang=js"
import style0 from "./analiseOrdem.vue?vue&type=style&index=0&id=ec1923d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports